import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, Row, Col, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import '../../styles/LoginForm.css'; // Import your CSS file
import { useNavigate } from 'react-router-dom';
import { loginService } from '../../services/AuthService';

const LoginForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // Loading state

  const onFinish = async (values) => {
    setLoading(true); // Start loading when submitting the form

    try {
      const { email, password } = values;
      const { token, user_status } = await loginService(email, password); // Call the login service
    
      if (user_status === 'INACTIVE') {
        message.warning('Your account needs to be approved by the admin team.'); // Show specific message for inactive accounts
      } else if (token) {
        message.success('Login successful!'); // Show success message
        navigate('/admin/home'); // Redirect to dashboard on successful login
      } else {
        message.error('Bad credentials, please try again.'); // Show error message if no token
      }
    } catch (error) {
      console.error('Login error:', error);
      message.error('Login failed, please try again.'); // Handle login failure
    } finally {
      setLoading(false); // Stop loading after request completes
    }
    
  };

  return (
    <Row justify="center" align="middle" className="login-form-container">
    <Col>
      <Form
        name="login_form"
        className="login-form"
        initialValues={{ remember: true }}
        onFinish={onFinish}
      >
        <div className="logo-container">
          <img src="/logo.png" alt="logo" className="logo-auth" />
        </div>
        
        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'Please enter your email!' },
            { type: 'email', message: 'The input is not a valid email!' },
          ]}
        >
          <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email" size="large" />
        </Form.Item>
  
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please enter your password!' }]}
        >
          <Input.Password 
            prefix={<LockOutlined className="site-form-item-icon" />} 
            placeholder="Password" 
            size="large" 
          />
         
        </Form.Item>
        <div className="forgot-password-link">
            <p 
              onClick={() => navigate('/forgot-password')}
              style={{ color: '#1890ff', cursor: 'pointer' }}
            >
              Forgot Password?
            </p>
          </div>
  
       
  
        <Form.Item>
          <Button 
            type="primary" 
            htmlType="submit" 
            className="login-form-button" 
            size="large" 
            loading={loading}
            block 
          >
            Log in
          </Button>
        </Form.Item>
  
        <Row justify="center" className="auth-footer">
          <p>Don't have an account? </p>
          <p 
            onClick={() => navigate('/register')} 
            style={{ color: '#1890ff', cursor: 'pointer', marginLeft: '5px' }}
          >
            Sign Up
          </p>
        </Row>
      </Form>
    </Col>
  </Row>
  );
};

export default LoginForm;
